import { useState, useEffect } from 'react';
import API from '../API';
import { getOrganizationEndDate } from '../utils/organizationEndDate';

export const useHome = () => {

    const [organizations, setOrganizations] = useState();
    const [allOrganizations, setAllOrganizations] = useState([]);
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('Active');
   

    const getOrganizations = async (searchTerm, statusFilter) => {
        try {
            setLoading(true);
            setError(''); // Clear any previous errors
            const response = await API.getOrganizations();
            if (response){
                const allData = response.data;
                setAllOrganizations(allData);
                
                let filteredData = allData;
                
                // Apply status filter
                if (statusFilter !== 'All') {
                    filteredData = filteredData.filter(org => org.subscriptionStatus === statusFilter);
                }
                
                // Apply search filter — matches organization name (case-insensitive
                // substring) or organization id (so pasting an id from a support
                // ticket / log / API response finds the tenant directly).
                if (searchTerm) {
                    const search = searchTerm.trim().toLowerCase();
                    filteredData = filteredData.filter(o =>
                        o.name.toLowerCase().indexOf(search) > -1 ||
                        String(o.id).includes(search)
                    );
                }
                
                setOrganizations(filteredData.slice(0,50));
            }
        }catch(error){
            setError(error)
            console.log('ERROR:', error)
        }finally {
             setLoading(false)
        }
    }

     //Load organizations when search term or status filter changes
     useEffect(()=>{
        getOrganizations(searchTerm, statusFilter);
    },[searchTerm, statusFilter])

    // Re-fetch with the current search term / status filter. Used after a
    // mutation (status change, end-date change) instead of a full page reload.
    const refresh = () => getOrganizations(searchTerm, statusFilter);

    // Summary counts for the stat cards on top of the list.
    // Always computed from the full fetched list, never the filtered slice.
    const stats = {
        total: allOrganizations.length,
        active: allOrganizations.filter(org => org.subscriptionStatus === 'Active').length,
        paused: allOrganizations.filter(org => org.subscriptionStatus === 'Paused').length,
        withEndDate: allOrganizations.filter(org => getOrganizationEndDate(org) !== null).length,
    };

    // Status filter options: fixed base list in mockup order, plus any
    // additional statuses that actually appear in the data.
    const getStatusOptions = () => {
        const baseOptions = [
            { value: 'All', label: 'All Organizations' },
            { value: 'Active', label: 'Active' },
            { value: 'Paused', label: 'Paused' },
            { value: 'Deleted', label: 'Deleted' },
        ];
        const knownValues = new Set(baseOptions.map(option => option.value));
        const extraOptions = [...new Set(allOrganizations.map(org => org.subscriptionStatus))]
            .filter(status => status && !knownValues.has(status))
            .map(status => ({ value: status, label: status }));

        return [...baseOptions, ...extraOptions];
    };

return { 
    organizations, 
    allOrganizations,
    error, 
    loading, 
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    stats,
    refresh,
    statusOptions: getStatusOptions()
};

}